export type LocationCoordinates = {
  lat: number;
  lon: number;
};

export type LabeledCoordinates = LocationCoordinates & {
  label?: string | null;
};
export type ExtendedCoordinates = LabeledCoordinates & Record<string, any>;

export const transformToLabeledCoordinates = <
  T extends { lat: number; lon: number; label?: string | null; name?: string | null },
>(
  locations: T[],
): ExtendedCoordinates[] => {
  return locations.map(({ lat, lon, label, name, ...rest }) => ({
    ...rest,
    lat,
    lon,
    label: label ?? name ?? undefined,
  }));
};

export const labeledLocationToLocationInfo = (
  location: LabeledCoordinates,
): { coordinates: LocationCoordinates; label?: string | null } => {
  return {
    coordinates: {
      lat: location.lat,
      lon: location.lon,
    },
    label: location.label ?? null,
  };
};

export const locationInfoToLabeledLocation = (locationInfo: {
  coordinates: LocationCoordinates;
  label?: string | null;
}): LabeledCoordinates => {
  return {
    lat: locationInfo.coordinates.lat,
    lon: locationInfo.coordinates.lon,
    label: locationInfo.label ?? undefined,
  };
};
